import { debounce } from '../../../js/default';

/**
 * Init Side Menu
 */
(() => {
  const menu = document.querySelector('.js-sidemenu-data');
  if (!menu) return;

  // setup and primary menu
  menu.insertAdjacentHTML('afterbegin', '<h2>Products</h2>');
  const sideMenu = document.createElement('section');
  const sideMenuContainer = document.createElement('div');
  const nOverlay = document.createElement('div');
  sideMenu.className = 'side-menu js-sidemenu';
  sideMenuContainer.className = 'side-menu-container';
  nOverlay.className = 'nOverlay js-togglenav';

  // add logo & close btn
  sideMenuContainer.insertAdjacentHTML('afterbegin', '<a class="logo" href="/"><img src="https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-head-logo-alt.png" alt="Heatons Group" /></a>');
  sideMenuContainer.insertAdjacentHTML('afterbegin', '<span class="close-menu js-togglenav" tabindex="0"><i class="fa fa-times" aria-hidden="true"></i></span>');

  menu.className = 'sidemenu-main js-sidemenu-main';
  sideMenuContainer.append(menu);

  // add secondary menu
  if (document.querySelector('.nav-services')) {
    document.querySelector('.nav-services > ul').classList.add('sidemenu-services');
    sideMenuContainer.append(document.querySelector('.sidemenu-services'));
  }

  // add tertiary menu
  if (document.querySelector('.nav-account')) {
    document.querySelector('.nav-account > ul').classList.add('sidemenu-account');
    sideMenuContainer.append(document.querySelector('.sidemenu-account'));
  }

  // add menu to page
  sideMenu.append(sideMenuContainer);
  document.querySelector('body > header').append(sideMenu);
  sideMenu.after(nOverlay);

  // Add bg colour if no T2 bg image found
  sideMenu.querySelectorAll('.submenucontainer').forEach((item) => {
    if (item.querySelector('.has-image img')) return;
    item.style.backgroundColor = '#2a4857';
  });

  document.querySelectorAll('.js-sidemenu-main .submenucontainer').forEach((item) => {
    // add view all to T3
    const viewAll = item.firstElementChild.querySelector(':scope > a').getAttribute('href');
    item.firstElementChild.querySelector('ul')?.insertAdjacentHTML('beforeend', `
      <li><a href="${viewAll}">View All</a></li>
    `);

    // Add T3 close / back link
    item.insertAdjacentHTML('afterbegin', '<span class="submenu-close">< Close</span>');
  });

  // activate secondary menu visibilty
  document.querySelector('.sidemenu-services > li:first-child')?.classList.add('nActive');
})();

/**
 * Menu Toggle Fn
 */
const toggleMenu = () => {
  const menu = document.querySelector('.js-sidemenu');

  // Remove active from all CHILDREN if closing menu
  menu.querySelector('.js-sidemenu-main .has-submenu.nActive')?.click();

  // Toggle state for menu
  menu?.classList.toggle('nActive');
  document.documentElement.classList.toggle('no-overflow');
};

/**
 * Submenu Toggle Fn
 */
const toggleSubMenu = (menuName) => {
  if (!menuName) return;

  const itemParent = menuName.closest('.catalog');

  if (itemParent) {
    if (menuName.classList.contains('nActive')) {
      menuName.classList.remove('nActive');
      itemParent.classList.remove('nActive');

      document.querySelectorAll('.sidemenu-services > .nActive').forEach((item) => {
        item.classList.remove('nActive');
      });
      document.querySelector('.sidemenu-services > li:first-child')?.classList.add('nActive');
    } else {
      document.querySelectorAll('.js-sidemenu-main .catalog > li.nActive').forEach((item) => {
        item.classList.remove('nActive');
      });
      menuName.classList.toggle('nActive');
      if (!itemParent.classList.contains('nActive')) {
        itemParent.classList.add('nActive');
      }

      const altNavName = document.querySelector(`.sidemenu-services .${menuName.classList[0]}`);
      if (altNavName) {
        document.querySelectorAll('.sidemenu-services > .nActive').forEach((item) => {
          item.classList.remove('nActive');
        });
        altNavName.classList.add('nActive');
      }
    }
  } else {
    console.log('External Click');
  }
};

/**
 * Submenu Toggle
 */
(() => {
  document.querySelectorAll('.js-sidemenu .catalog > .has-submenu').forEach((item) => {
    item.addEventListener('click', (e) => {
      if (e.target !== e.currentTarget
        && e.target !== e.currentTarget.querySelector(':scope > a')
        && e.target !== e.currentTarget.querySelector('.submenu-close')) return;
      toggleSubMenu(e.currentTarget);
    });
  });
})();

/**
 * Class to toggle menu
 */
(() => {
  document.querySelectorAll('.js-togglenav').forEach((item) => {
    item.addEventListener('click', toggleMenu);
  });
})();

/**
 *
 * Divisions Sticky Tab
 *
 */

/**
 * Sticky Division Tab Init
 */
(() => {
  const sidemenu = document.querySelector('.js-sidemenu-main');
  if (!sidemenu) return;
  if (!document.querySelector('.ex-home') && !document.querySelector('.js-division-popout')) return;

  const divisionTab = document.createElement('div');
  divisionTab.className = 'division-popout nHidden';

  divisionTab.innerHTML = /* html */ `
    <div class="popout-bg"></div>
    <div class="popout-title js-popout-toggle">
      Explore Our <span class="text-orange">Divisions
      <span class="popout-toggle"></span>
    </div>
    <ul class="nList"></ul>
    <p>Learn More <i class="fa fa-chevron-right"></i></p>
  `;

  sidemenu.querySelectorAll('.catalog > li > a').forEach((item) => {
    const division = item.cloneNode('false');
    const li = document.createElement('li');
    const img = item.nextElementSibling.querySelector('img[title="Menu Background"]').cloneNode('false');

    division.setAttribute('href', division.getAttribute('data-url'));
    li.append(division);

    divisionTab.querySelector('.popout-bg').append(img);
    divisionTab.querySelector('ul').append(li);
  });

  document.body.append(divisionTab);

  // Toggle visibility when not at top of page
  function saveInput() {
    const windowHeight = window.innerHeight;
    const scrollHeight = window.scrollY;

    if (scrollHeight > (windowHeight / 2)) {
      document.querySelector('.division-popout')?.classList.remove('nHidden');
    } else {
      document.querySelector('.division-popout')?.classList.add('nHidden');
    }
  }
  const processChange = debounce(() => saveInput());

  document.addEventListener('scroll', () => {
    processChange();
  });
})();

/**
 * Sticky Division Tab Toggle
 */
(() => {
  document.querySelectorAll('.js-popout-toggle').forEach((item) => {
    item.addEventListener('click', () => {
      document.querySelector('.division-popout')?.classList.toggle('nActive');
    });
  });
})();

/**
 * Sticky Division Tab Link Hover
 */
(() => {
  document.querySelectorAll('.division-popout li a').forEach((item) => {
    item.addEventListener('mouseenter', (e) => {
      const ele = e.currentTarget;
      const id = Array.from(ele.parentNode.parentNode.children).indexOf(ele.parentNode);

      ele.closest('.division-popout').querySelectorAll('img').forEach((img) => {
        img.classList.remove('nActive');
      });

      ele.closest('.division-popout').querySelector('.popout-bg').children[id].classList.add('nActive');
    });
  });
})();
